import toast from "react-hot-toast";
import { NavigateFunction } from "react-router-dom";

// Message for an error response without a JSON body, typically produced by the
// reverse proxy (upload too large, server unreachable or too slow) rather than
// by the backend itself.
const describeHttpError = (status: number): string => {
  if (status === 413) {
    return "Fichier trop volumineux, l'envoi a été refusé";
  }
  if (status === 502 || status === 503 || status === 504) {
    return "Le serveur n'a pas répondu à temps, veuillez réessayer";
  }
  return `Erreur ${status}, la requête n'a pas abouti`;
};

const isMutation = (options?: RequestInit): boolean =>
  !!options?.method && options.method.toUpperCase() !== "GET";

async function appFetch(
  route: string,
  options?: RequestInit,
  navigate?: NavigateFunction,
) {
  try {
    const response = await fetch(route, {
      ...options,
      credentials: "include",
    });

    // Handle too many requests
    if (response.status === 429) {
      toast.error("Trop de requêtes, veuillez réessayer plus tard");
      return null;
    }

    // Handle no organization
    if (response.status === 401) {
      if (navigate) {
        navigate("/organizationSetup");
      }
      return { message: "Vous n'avez pas de'organisation", error: 401 };
    }

    const contentType = response.headers.get("content-type");

    // Handle forbidden access. Reads stay silent (pages probe access on load),
    // but a rejected save must not look like it went through.
    if (response.status === 403) {
      if (isMutation(options)) {
        toast.error("Session expirée, reconnectez-vous puis réessayez");
      }
      return null;
    }
    if (response.status === 402) {
      if (navigate) {
        navigate("/payment/create");
      }

      return { message: "Payment required" };
    }

    // Handle successful response
    if (response.ok) {
      if (
        (contentType && contentType.indexOf("application/pdf") !== -1) ||
        (contentType && contentType === "image/png") ||
        (contentType && contentType === "application/zip")
      ) {
        return await response.blob();
      } else {
        return await response.json();
      }
    } else {
      try {
        const responseData = await response.json();
        toast.error(
          responseData.message ||
            responseData.error ||
            describeHttpError(response.status),
        );
      } catch {
        toast.error(describeHttpError(response.status));
      }
      return null;
    }
  } catch (error) {
    if (error instanceof Error) {
      toast.error(error.message);
    } else {
      toast.error("Une erreur inconnue s'est produite");
    }
    throw error;
  }
}

export default appFetch;
